import { css } from '@emotion/react'

const text = theme => css`
  position: relative;
  overflow: hidden;

  &:before {
    content: '';
    top: 50%;
    left: 0;
    width: 100%;
    height: 100%;
    position: absolute;
    background-image: radial-gradient(
      circle,
      ${theme.color.monochrome.superLight} 0%,
      ${theme.color.monochrome.transparent} 80%
    );
  }
`

const showMore = theme => css`
  font-size: ${theme.fontSize.tiny};
  font-weight: ${theme.fontWeight.medium};
  color: ${theme.color.monochrome.mediumDark};
  cursor: pointer;

  &:hover {
    color: ${theme.color.primary.brand};
  }
`

export const styles = {
  text,
  showMore,
}
